<template>
  <span>
    <!--NxN-->
    <span style="text-align:left;" v-if="campo.cmp_join_tipo == 'NxN'">
      <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
        <v-layout row style="margin-top:0px;" class="mt-2">
          <v-flex pa-0 ma-0>
            <v-input
              :value="multiples"
              required
              :rules="crud.evalrules(campo)"
              :hint="T(campo.cmp_dica)"
              persistent-hint
            >
              <a-transfer
                :list-style="{
                  width: '350px',
                  height: '350px'
                }"
                :locale="{
                  itemUnit: T('item'),
                  itemsUnit: T('itens'),
                  notFoundContent: T('Nenhum item'),
                  searchPlaceholder: T('Pesquisa')
                }"
                :data-source="items"
                show-search
                :filter-option="filterMethod"
                :target-keys="multiples"
                :render="item => item.title"
                @change="handleChange"
                @search="handleSearch"
                :showSelectAll="true"
                :showSearch="true"
              />

              <span v-if="getComponentParam('addmore') != null">
                <v-btn
                  fab
                  dark
                  small
                  color="warning"
                  class="mt-3"
                  @click="displayDialog = true"
                >
                  <v-icon>add</v-icon>
                </v-btn>

                <v-dialog v-if="displayDialog" v-model="displayDialog">
                  <v-card>
                    <v-card-title
                      class="headline grey lighten-2"
                      primary-title
                      >{{
                        T(getComponentParam("titulo") || "Incluir indicador")
                      }}</v-card-title
                    >

                    <v-card-text>
                      <crud-tag
                        :embedprops="{
                          params: {
                            module: getComponentParam('tabela') || 'indicador',
                            action: 'new'
                          },
                          props: {
                            filtro: false,
                            gc: false,
                            rodape: true,
                            paginacao: false,
                            titulo: false,
                            select: false,
                            exportserver: false
                          }
                        }"
                        :backfn="() => addnewBack()"
                        :returnfn="data => addnewSave(data)"
                      />
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </span>
            </v-input>
          </v-flex>
        </v-layout>
      </template>

      <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
        <span :class="{ 'text-xs-center': modo == 'list' }">{{
          valoramostrar
        }}</span>
      </template>

      <template v-if="modo == 'filtro'">
        <v-select
          :items="itensSelectMostrar"
          item-text="v"
          clearable
          item-value="k"
          hide-details
          class="ma-0 pa-1"
          height="20"
          v-bind:value="preLoad(value)"
          v-on:input="event => $emit('input', preUpdate(event))"
          background-color="#fcfcfc"
        ></v-select>
      </template>
    </span>
  </span>
</template>

<script>
const Api = global.Api;
try {
  var bus = require("@/admin/elements/inc/bus").default;
} catch (err) {
  var bus = require("@/framework/admin/elements/inc/bus").default;
}

try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {
      mockData: [],
      targetKeys: [],
      value2: [],
      filterMethod(query, item) {
        return item.title.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      loading: false,
      lockval: false,
      intravalue: this.preLoad(this.value),
      multiples: this.preLoad(this.value),
      items: (() => {
        //return [];

        if (this.row._extra) {
          let array = this.row._extra[this.campo.cmp_coluna];
          return array;
        }
        if (this.crud.metadataextra) {
          let array = this.crud.metadataextra[this.campo.cmp_coluna];
          return array;
        }
      })().map(i => {
        return { key: i.k * 1, title: i.v, chosen: false };
      }),
      displayDialog: false
    };
  },
  created() {
    bus.$off(
      "crud_" +
        this.crud.sid +
        "_" +
        this.campo.cmp_coluna +
        "_refresh" +
        this.modo
    );
    bus.$on(
      "crud_" +
        this.crud.sid +
        "_" +
        this.campo.cmp_coluna +
        "_refresh" +
        this.modo,
      () => {
        this.fazAsync();
      }
    );
  },
  destroy() {
    bus.$off(
      "crud_" +
        this.crud.sid +
        "_" +
        this.campo.cmp_coluna +
        "_refresh" +
        this.modo
    );
  },

  computed: {
    valoramostrar() {
      if (this.value == null) return "";

      if (
        this.campo.cmp_tipo == "join" &&
        this.campo.cmp_join_tipo.substr(0, 3) == "NxN"
      )
        return this.value;

      let tabela = this.crud.module;
      if (tabela.indexOf("_v_") != -1) tabela = tabela.split("_v_")[0];

      if (
        this.row[
          "_join_" +
            this.campo.cmp_coluna +
            "_" +
            tabela +
            "_" +
            this.campo.cmp_join_tabela
        ] == null
      )
        return "";

      return this.row[
        "_join_" +
          this.campo.cmp_coluna +
          "_" +
          tabela +
          "_" +
          this.campo.cmp_join_tabela
      ]._joined;
    },
    itensSelectMostrar() {
      if (this.crud.localsession != null) {
        let locases = this.crud.localsession[this.crud.sid];
        if (
          this.modo != "filtro" &&
          locases.joined != null &&
          locases.joined == this.campo.cmp_coluna
        ) {
          if (this.row._extra) {
            let array = this.row._extra[this.campo.cmp_coluna].filter(
              v => v.k == locases.joinedid
            );
            return array;
          }
        }
      }

      if (this.row._extra) {
        let array = this.row._extra[this.campo.cmp_coluna];
        return array;
      }
      if (this.crud.metadataextra) {
        let array = this.crud.metadataextra[this.campo.cmp_coluna];
        return array;
      }
      return [];
    },

    addmoreNN() {
      let info = this.getComponentParam("addmore");
    }
  },
  mounted() {
    this.getMock();
    if (this.crud.localsession != null) {
      let locases = this.crud.localsession[this.crud.sid];
      if (
        this.modo != "filtro" &&
        locases.joined != null &&
        locases.joined == this.campo.cmp_coluna &&
        this.row != null &&
        this.row._extra != null &&
        this.row._extra[this.campo.cmp_coluna] != null
      ) {
        if (locases.joinedid < 0) {
          //this.value = locases.joinedid;
          this.$emit("input", locases.joinedid);
          this.crud.form[this.campo.cmp_coluna] = locases.joinedid;
          this.lockval = { k: locases.joinedid, v: "Módulo atual" };
        } else {
          //this.value = locases.joinedid;
          setTimeout(() => {
            this.$emit("input", locases.joinedid);
          }, 100);

          this.crud.form[this.campo.cmp_coluna] = locases.joinedid;

          this.lockval = this.row._extra[this.campo.cmp_coluna].filter(
            v => v.k == locases.joinedid
          );
          this.lockval =
            this.lockval != null && this.lockval.length > 0
              ? this.lockval[0]
              : false;
          this.$forceUpdate();
        }
      }
    }
  },

  methods: {
    getMock() {
      //this.targetKeys = this.items.filter(f=>f.chosen).map(f=>f.key);
    },
    filterOption(inputValue, option) {
      return option.description.indexOf(inputValue) > -1;
    },
    handleChange(targetKeys, direction, moveKeys) {
      //console.log(targetKeys, direction, moveKeys);
      this.multiples = targetKeys;
    },
    handleSearch(dir, value) {
      //console.log('search:', dir, value);
    },

    cambiar(opt) {
      if (this.multiples.indexOf(opt.k) === -1) this.multiples.push(opt.k);
      else this.multiples.splice(this.multiples.indexOf(opt.k), 1);
    },
    preLoad(myval) {
      if (this.campo.cmp_join_tipo == "select" || this.modo == "filtro") {
        if (myval == undefined) return null;
        return myval;
      }
      if (this.campo.cmp_join_tipo == "radio") {
        if (myval == undefined) return null;
        return myval;
      }
      if (this.campo.cmp_join_tipo.substr(0, 3) == "NxN") {
        if (myval == undefined || myval == null) return [];
        return myval;
      }
    },
    preUpdate(myval) {
      return myval;
    },
    alterouSelectRadio() {
      let params = this.getComponentParam("updates");
      if (params != null && params != "") {
        params
          .split(",")
          .map(v => v.trim())
          .forEach(alvo => {
            bus.$emit(
              "crud_" + this.crud.sid + "_" + alvo + "_refresh" + this.modo
            );
          });
      }
    },
    fazAsync() {
      this.loading = true;

      let clone = _.clone(this.crud.localsession[this.crud.sid]);
      delete clone["filtro"];

      if (this.modo != "filtro")
        clone.master = _.pickBy(
          this.crud.form,
          (v, k) => !_.startsWith(k, "_")
        );
      else {
        clone.master = _.clone(this.crud.localsession[this.crud.sid].filtro);
      }

      let credentials = {
        module: this.crud.module,
        localsession: clone,
        column: this.campo.cmp_coluna,
        action: "actionComponentUpdate"
      };
      Api()
        .post("admin/crud/async", credentials)
        .then(result => {
          if (result.data.output !== null) {
            if (this.modo != "filtro") {
              this.row._extra[this.campo.cmp_coluna] = result.data.output;
              this.items = this.row._extra[this.campo.cmp_coluna];
              this.crud.form[this.campo.cmp_coluna] = null;
              if (this.campo.cmp_join_tipo.substr(0, 3) == "NxN")
                this.multiples = [];
            } else {
              this.crud.metadataextra[this.campo.cmp_coluna] =
                result.data.output;
              this.items = this.crud.metadataextra[this.campo.cmp_coluna];
              this.crud.localsession[this.crud.sid].filtro[
                this.campo.cmp_coluna
              ] = null;
            }

            this.alterouSelectRadio();
          }

          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    addnewBack() {
      this.displayDialog = false;
    },
    addnewSave(data) {
      //console.log('added', data)
      this.row._extra[this.campo.cmp_coluna].push({
        k: data.id,
        v: data[this.campo.cmp_join_mostra]
      });

      this.items.push({
        key: data.id,
        title: data[this.campo.cmp_join_mostra],
        chosen: true
      });
      this.multiples.push(data.id);
      this.displayDialog = false;
    }
  },
  watch: {
    intravalue(val) {
      this.$emit("input", this.preUpdate(val));
      if (this.campo.cmp_join_tipo == "radio") {
        setTimeout(() => this.alterouSelectRadio(), 500);
      }
    },
    multiples(val) {
      this.$emit("input", this.preUpdate(val));
    },
    value: {
      handler(val) {
        this.multiples = this.value;
        this.$forceUpdate();
      },
      deep: true
    }
  }
};
</script>

<style>
.el-transfer__buttons {
  padding: 0 10px;
}
</style>
